"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrate = exports.preload = exports.getPreloadStrategy = exports.getCeloPreloadDataUpdates = exports.getCurrentCeloPreloadData = void 0;
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const logs_1 = require("@ledgerhq/logs");
const logic_1 = require("./logic");
const validators_1 = require("./validators");
let currentCeloPreloadedData = {
    validatorGroups: [],
};
function fromHydrateValidator(validatorGroupRaw) {
    return {
        address: validatorGroupRaw.address,
        name: validatorGroupRaw.name,
        votes: new bignumber_js_1.BigNumber(validatorGroupRaw.votes),
    };
}
function fromHydratePreloadData(data) {
    let validatorGroups = [];
    if (typeof data === "object" && data) {
        if (Array.isArray(data.validatorGroups)) {
            validatorGroups = data.validatorGroups.map(fromHydrateValidator);
        }
    }
    return {
        validatorGroups,
    };
}
const updates = new rxjs_1.Subject();
function getCurrentCeloPreloadData() {
    return currentCeloPreloadedData;
}
exports.getCurrentCeloPreloadData = getCurrentCeloPreloadData;
function setCeloPreloadData(data) {
    if (data === currentCeloPreloadedData)
        return;
    currentCeloPreloadedData = data;
    updates.next(data);
}
function getCeloPreloadDataUpdates() {
    return updates.asObservable();
}
exports.getCeloPreloadDataUpdates = getCeloPreloadDataUpdates;
const getPreloadStrategy = () => ({
    preloadMaxAge: logic_1.PRELOAD_MAX_AGE,
});
exports.getPreloadStrategy = getPreloadStrategy;
const preload = () => __awaiter(void 0, void 0, void 0, function* () {
    const { validatorGroups: previousValidatorGroups } = currentCeloPreloadedData;
    let validatorGroups = previousValidatorGroups;
    if (!validatorGroups || !validatorGroups.length) {
        (0, logs_1.log)("celo/preload", "refreshing celo validatorGroups...");
        try {
            validatorGroups = yield (0, validators_1.getValidatorGroups)();
        }
        catch (error) {
            (0, logs_1.log)("celo/preload", "failed to fetch validatorGroups", {
                error,
            });
        }
    }
    return { validatorGroups };
});
exports.preload = preload;
const hydrate = (data) => {
    const hydrated = fromHydratePreloadData(data);
    (0, logs_1.log)("celo/preload", "hydrate " + hydrated.validatorGroups.length + " celo validatorGroups");
    setCeloPreloadData(hydrated);
};
exports.hydrate = hydrate;
//# sourceMappingURL=preload.js.map